import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '../../../app/app.state';
import {TitleBreadcrumbsChangedAction, TitleChangedAction} from '../../../core/actions/title.actions';
import {SessionService} from '../../../core/services/session.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SearchService} from '../../../core/services/search.service';
import {Subscription} from 'rxjs';
import {UserBearerToken} from '../../../shared/responses/bearer-token';
import {NativeService} from '../../../core/services/native.service';
import {CURRENT_PLATFORM} from '../../../core/services/env.service';
import {Platform} from '../../../core/models/platform.enum';
import {FormsModule} from '@angular/forms';
import {NgClass} from '@angular/common';
import {SpinnerComponent} from '../../components/spinner/spinner.component';
import {LoginHelpButtonsComponent} from '../../components/login-help-buttons/login-help-buttons.component';

@Component({
  selector: 'motn-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    NgClass,
    SpinnerComponent,
    LoginHelpButtonsComponent,
  ],
})
export class LoginComponent implements OnInit, OnDestroy {
  private routeSub: Subscription;

  enteredUsername: string = '';
  enteredPassword: string = '';
  enteredTotpCode: string = '';

  loginBadAttempt: boolean = false;
  loginAttempting: boolean = false;

  totpBadAttempt: boolean = false;
  totpAttempting: boolean = false;

  totpEntryMode: boolean = false;


  constructor(
    private store: Store<AppState>,
    private session: SessionService,
    private native: NativeService,
    private search: SearchService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
  }


  ngOnInit(): void {
    this.goToApps();

    this.store.dispatch(new TitleChangedAction(
      '',
      '',
    ));

    this.store.dispatch(new TitleBreadcrumbsChangedAction([]));

    this.search.disableSearch();

    this.routeSub = this.route.queryParamMap.subscribe((params) => {
      const emulate: string = params.get('emulate');

      if (emulate) {
        let data: UserBearerToken = JSON.parse(emulate);
        this.session.runEmulation(data);
      }
    });
  }


  get isWeb(): boolean {
    return CURRENT_PLATFORM === Platform.WEB;
  }


  ngOnDestroy() {
    this.routeSub.unsubscribe();
  }


  goToApps() {
    if (this.session.hasAuthenticated()) {
      this.router.navigate(['/apps'], {
        replaceUrl: true,
      });
    }
  }


  attemptLogin($event) {
    const u = this.enteredUsername;
    const p = this.enteredPassword;

    this.loginAttempting = true;

    this.session.authenticate$(u, p).subscribe({
      next: (data) => {
        if (data.User.TOTPEnabled) {
          this.loginAttempting = false;
          this.totpEntryMode = true;
          this.native.hideKeyboard();
        } else {
          this.goToApps();
        }
      },
      error: (data) => {
        this.loginBadAttempt = true;
        this.loginAttempting = false;
      },
    });
  }


  attemptTotpValidation($event) {
    const t = this.enteredTotpCode;

    this.totpAttempting = true;

    this.session.validateTotp$(t).subscribe(
      (data) => {
        this.goToApps();
      },
      () => {
        this.totpBadAttempt = true;
        this.totpAttempting = false;
        this.enteredTotpCode = '';
      },
    );
  }


  resetInvalidState(): void {
    this.loginBadAttempt = false;
    this.totpBadAttempt = false;
  }
}
